export default {
  // uni-app 回到顶部
  uniapp_to_top: (duration = 300) => {
    uni.pageScrollTo({ scrollTop: 0, duration })
  },
  // uni-app 后退页面
  uniapp_back: (delta = 1) => {
    uni.navigateBack({ delta })
  },
}
